import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { BOOTH_API_URL, EVENT_FOLDER, EVENT_ID, getUserID } from '../constants';
import axios from 'axios';

import { ImHome } from 'react-icons/im';
import { GrDocumentPdf } from 'react-icons/gr';

// import Stampbook from './Stampbook';

const styles = (theme) => ({
  dialogTitle: {
    // padding: '24px 32px',
  },
  docBtn: {
    boxShadow: 'none',
    borderRadius: 0,
    backgroundColor: '#4d4d4d',
    color: '#ffffff',
    width: '95%',
  },
  corpName: {
    fontWeight: 700,
    fontSize: '20px',
    color: theme.palette.primary.main,
  },
  corpHomepage: {
    fontWeight: 500,
    color: '#7f1084',
    fontSize: '10px',
    cursor: 'pointer',
    wordBreak: 'break-all',
  },
  dialogContent: {
    padding: '8px 32px 24px',
  },
  vodDiv: {
    border: '1px solid #eeeeee',
    borderRadius: '5px',
    padding: '10px',
    height: '100%',
  },
  boothDiv: {
    display: 'none',
    border: '1px solid #eeeeee',
    borderRadius: '5px',
    padding: '10px',
    textAlign: 'center',
  },
  visitBtn: {
    boxShadow: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    width: '50%',
  },
});

class BoothDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisit: false,
      isAgree: false,
      initOpen: false,
      visitOpen: false,
      matches: window.matchMedia('(max-width:960px)').matches,
    };
  }

  componentDidMount() {
    // console.log(this.props.data);
    // console.log(this.props.data.logoalt);
    // console.log(this.props.data.mp4);
  }

  closeInitDialog = (event) => {
    this.setState({ initOpen: false });
  };

  openVisitDialog = (event) => {
    this.setState({ visitOpen: true });
  };

  closeVisitDialog = (event) => {
    this.setState({ visitOpen: false, isVisit: true });
  };

  handleAgree = (event) => {
    this.setState({ isAgree: event.target.checked });
  };

  visitBooth() {
    if (this.state.isAgree === true) {
      axios
        .get(
          `${BOOTH_API_URL}/booth/visit?evt=${EVENT_ID}&name=${encodeURIComponent(
            sessionStorage.getItem('_in_name'),
          )}&userid=${getUserID()}&booth=${this.props.data.id}&position=atoz`,
        )
        .then((data) => {
          this.setState({ visitOpen: true });
          //alert("부스참여하기가 완료되었습니다.");
          this.props.data.visit = true;
          this.props.emitBoothVisit(this.props.id);
        })
        .catch((err) => {
          alert('부스참여하기에 실패하였습니다. 다시 시도해주세요.');
        });
    } else {
      this.setState({ initOpen: true });
    }
  }

  render() {
    const { open, onClose, classes } = this.props;

    let vodAddress;
    if (!this.props.data.vod) {
      vodAddress = '488110729'; //vod값이 없는 경우 임의로 지정해놓음
    } else {
      vodAddress = this.props.data.vod.replace('https://vimeo.com/', '');
    }

    return (
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={onClose}
          aria-labelledby="booth-dialog-title"
          open={open}
          // disableBackdropClick={false}
          // disableEscapeKeyDown={false}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Grid container justifyContent="center" alignItems="center" alignContent="center">
              <Grid id="corp_name" container item xs={12} justifyContent="center" style={{ paddingBottom: '10px' }}>
                {this.props.data && this.props.data.name && <Typography className={classes.corpName}>{this.props.data.name}</Typography>}
              </Grid>

              <Grid id="logo_and_name" container justifyContent="center" style={{ paddingBottom: '10px' }}>
                <Grid container item xs={7}>
                  {this.props.data && this.props.data.logo && (
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={11}
                      style={{ border: '1px solid #efefef', boxShadow: '4px 4px 4px -4px #000000' }}
                    >
                      {this.props.data.logo && this.props.data.id === 'evt113_999' ? (
                        <img
                          src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_custom.gif`}
                          style={{ width: '90% ' }}
                          alt={''}
                        />
                      ) : (
                        <img
                          src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.data.logo}.png`}
                          style={{ width: '90% ' }}
                          alt={''}
                        />
                      )}
                    </Grid>
                  )}
                </Grid>
                <Grid item xs={5} container justifyContent="flex-end">
                  {this.props.data && this.props.data.homepage && this.props.data.id === 'evt095_001' ? (
                    <IconButton
                      aria-label="home"
                      onClick={() => {
                        window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/pdf/${this.props.data.doc1}`, '_blank');
                      }}
                      fullWidth={true}
                      style={{ border: '1px solid #efefef', borderRadius: '1px', boxShadow: '2px 2px 2px -2px #000000' }}
                    >
                      <GrDocumentPdf size={30} />
                    </IconButton>
                  ) : (
                    <IconButton
                      aria-label="home"
                      onClick={() => window.open(`${this.props.data.homepage}`, '_blank')}
                      fullWidth={true}
                      style={{ border: '1px solid #efefef', borderRadius: '1px', boxShadow: '2px 2px 2px -2px #000000' }}
                    >
                      <ImHome size={30} />
                    </IconButton>
                  )}
                </Grid>
              </Grid>

              <Grid id="pdf" container justifyContent="center" item xs={12} style={{ padding: '10px 0' }}>
                {this.props.data && this.props.data.homepage && this.props.data.id === 'evt095_001' ? (
                  <>
                    <Grid item xs={6} container justifyContent="flex-start">
                      {this.props.data && this.props.data.doc1 && (
                        <Button
                          variant="contained"
                          className={classes.docBtn}
                          style={{ fontSize: '12px' }}
                          onClick={() => window.open(`${this.props.data.homepage}`, '_blank')}
                        >
                          HOMEPAGE 1
                        </Button>
                      )}
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end">
                      {this.props.data.doc2 && (
                        <Button
                          variant="contained"
                          className={classes.docBtn}
                          style={{ fontSize: '12px' }}
                          onClick={() => window.open(`${this.props.data.doc2}`, '_blank')}
                        >
                          HOMEPAGE 2
                        </Button>
                      )}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={6} container justifyContent="flex-start">
                      {this.props.data && this.props.data.doc1 && this.props.data.doc1.length > 1 && (
                        <Button
                          variant="contained"
                          className={classes.docBtn}
                          style={{ fontSize: '12px' }}
                          onClick={() => {
                            window.open(
                              `https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/pdf/${this.props.data.doc1}`,
                              '_blank',
                            );
                          }}
                        >
                          BROCHURE 1
                        </Button>
                      )}
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end">
                      {this.props.data && this.props.data.doc2 && this.props.data.doc2.length > 1 && (
                        <Button
                          variant="contained"
                          className={classes.docBtn}
                          style={{ fontSize: '12px' }}
                          onClick={() => {
                            window.open(
                              `https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/pdf/${this.props.data.doc2}`,
                              '_blank',
                            );
                          }}
                        >
                          BROCHURE 2
                        </Button>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <div style={{ position: 'absolute', top: 0, right: 0 }}>
              <IconButton onClick={onClose} className={classes.closeBtn}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent className={classes.dialogContent}>
            <>
              {this.state.matches ? (
                // DialogContent 모바일 뷰
                <Grid container spacing={3}>
                  <Grid item xs={12} style={{ padding: 0, margin: '5px 0 7px' }}>
                    {this.props.data && this.props.data.mp4 !== '' ? (
                      <div className={classes.vodDiv}>
                        {this.props.data.vod && this.props.data.id !== 'evt113_008' && this.props.data.id !== 'evt113_014' && (
                          <iframe
                            id="player"
                            type="text/html"
                            width="100%"
                            height="100%"
                            title="vod"
                            src={`https://player.vimeo.com/video/${vodAddress}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media;"
                          />
                        )}
                        {this.props.data.id === 'evt113_008' && (
                          <iframe
                            id="player"
                            type="text/html"
                            width="100%"
                            height="100%"
                            title="vod"
                            src={`https://hanmi.ap.panopto.com/Panopto/Pages/Embed.aspx?id=33333508-eb55-4d42-8c6f-ae4e00628d43&showbrand=false&autoplay=true&showTitle=false`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media;"
                            allowFullscreen
                          />
                        )}
                        {this.props.data.id === 'evt113_014' && (
                          <iframe
                            id="player"
                            type="text/html"
                            width="100%"
                            height="100%"
                            title="vod"
                            src={'https://www.youtube.com/embed/sjkH8X1LV6A'}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullscreen
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        className={classes.vodDiv}
                        style={{ height: '384.67px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <img
                          alt={''}
                          src={`https://innon.s3.ap-northeast-2.amazonaws.com/2021summer/logo/${this.props.logoalt}`}
                          style={
                            this.props.data.id === 'evt003_32' || (this.props.data.id === 'evt003_18' && this.state.matches)
                              ? { width: '100%', height: 'auto' }
                              : { width: 'auto', height: '100%' }
                          }
                        />
                      </div>
                    )}
                  </Grid>
                  {/* <Grid item xs={12} style={{ padding: 0 }}>
                    <div className={classes.boothDiv}>
                      <Stampbook datas={this.props.datas} data={this.props.data} />
                    </div>
                  </Grid> */}
                </Grid>
              ) : (
                // DialogContent 웹 뷰
                ''
              )}
            </>
          </DialogContent>
        </Dialog>

        {/* 처음 들어갔을때 뜨는 Dialog */}
        {/* <Dialog maxWidth={'xs'} onClose={this.closeInitDialog} open={this.state.initOpen} disableBackdropClick disableEscapeKeyDown>
          <DialogContent style={{ padding: '20px 24px' }}>
            <Grid style={{ padding: '10px' }}>
              <div style={{ fontSize: '18px', textAlign: 'center', fontWeight: 'bold', marginBottom: '10px' }}>
                개인정보 제공 동의에 동의해주세요.
              </div>
              <div style={{ textAlign: 'center', fontWeight: 500, color: '#828282' }}>
                개인정보 제공에 동의하시면
                <br />
                성함, 소속, 이메일 주소가 업체에 공개됩니다.
              </div>
            </Grid>
            <Grid container justify="center" style={{ padding: '10px' }}>
              <Button onClick={this.closeInitDialog} variant="contained" color="primary" style={{ width: '100%' }}>
                <Typography variant="button" size="large">
                  확인
                </Typography>
              </Button>
            </Grid>
          </DialogContent>
        </Dialog> */}

        {/* 방문완료 Dialog */}
        {/* <Dialog maxWidth={'xs'} onClose={this.closeVisitDialog} open={this.state.visitOpen} disableBackdropClick disableEscapeKeyDown>
          <DialogContent style={{ padding: '20px 24px' }}>
            <Grid style={{ padding: '15px 40px' }}>
              <div style={{ fontSize: '18px', textAlign: 'center', fontWeight: 'bold', marginBottom: '10px' }}>
                <span style={{ color: '#7f1084' }}>방문완료</span> 되었습니다.
              </div>
            </Grid>
            <Grid container justify="center" style={{ padding: '10px' }}>
              <Button onClick={this.closeVisitDialog} variant="contained" color="primary" style={{ width: '100%' }}>
                <Typography variant="button" size="large">
                  확인
                </Typography>
              </Button>
            </Grid>
          </DialogContent>
        </Dialog> */}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(BoothDialog);
